var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMagixLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 35,
    viewBox: "0 0 22 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Asset 15 1",
    clipPath: "url(#clip0_2148_1227)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21.9999 0V17.5767C21.9999 12.9274 17.5986 11.7815 17.5986 7.17596C17.5986 4.32686 19.104 1.6938 21.5436 0.266124L21.9999 0Z",
    fill: "url(#paint0_linear_2148_1227)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M17.5988 7.17578V14.1232L8.80248 7.63915V20.5696C8.80248 21.2897 8.90801 21.9378 9.10666 22.5421L5.48448 19.8715C5.37585 19.7901 5.27652 19.7055 5.18341 19.6116H5.1803C1.59537 16.4212 1.44018 12.0756 4.40124 10.2002L3.94808 10.4663C1.50226 11.8971 0 14.5271 0 17.3762V17.4732C0 22.0819 4.39814 23.2278 4.39814 27.8771V20.7794L13.1975 27.2634V14.3298C13.1975 13.616 13.0858 12.9616 12.884 12.3511L16.5124 15.0249C16.6179 15.1094 16.7173 15.1971 16.8166 15.2879C20.4015 18.4782 20.5567 22.874 17.5957 24.7494L18.0364 24.4926C20.4884 23.0649 21.9969 20.4288 21.9969 17.5765C21.9969 12.9272 17.5957 11.7813 17.5957 7.17578H17.5988Z",
    fill: "#3ECF8E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M5.17711 19.6085C1.59217 16.4212 1.43698 12.0756 4.39804 10.2002V17.7237C4.39804 18.4375 4.6836 19.1138 5.17711 19.6085Z",
    fill: "url(#paint1_radial_2148_1227)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M16.8164 15.2881C20.4013 18.4753 20.5565 22.8742 17.5955 24.7496V17.2261C17.5955 16.5123 17.3099 15.7828 16.8164 15.2881Z",
    fill: "url(#paint2_radial_2148_1227)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M0 35V17.4233C0 22.0727 4.40124 23.2186 4.40124 27.8241C4.40124 30.6732 2.89588 33.3062 0.456264 34.7339L0 35Z",
    fill: "url(#paint3_radial_2148_1227)"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2148_1227",
    x1: 21.9626,
    y1: 8.76644,
    x2: 19.1064,
    y2: 10.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#5BB888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#55B585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#45AD7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#32A472"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_2148_1227",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(4.33874 11.3988) rotate(82.0285) scale(5.69096 3.49911)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5BB888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#57B685"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#4BB07F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#38A775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#32A472"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_2148_1227",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.0153 23.6192) rotate(-97.9715) scale(5.72227 3.51836)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5BB888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#57B685"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#4BB07F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#38A775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#32A472"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_2148_1227",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0.415378 31.1272) rotate(-105.72) scale(10.757 5.76604)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#5BB888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#57B685"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#4BB07F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#38A775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#32A472"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2148_1227"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 35,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagixLogo);
export default __webpack_public_path__ + "static/media/magixLogo.4b7bd1a18ca0c0d278666f4106f4a274.svg";
export { ForwardRef as ReactComponent };